import React from "react"
import "../styles/index.css"
import { Link } from "react-router-dom"

export default function NavBar(){


    const [active, setActive] = React.useState('items')
    const [icon, setIcon] = React.useState('hambugger')

    const navToggle = () =>{
        active === 'items' ? setActive('items active') : setActive('items')
        icon === 'hambugger' ? setIcon('hambugger cross') : setIcon('hambugger')
    }
    return(

        <section>
        <header>
            <nav className="shadow-lg">
                <div className="logo text-2xl">
                    WALOBWA
                </div>

                <div className={active}>
                    <ul>
                        <li><a href="/" className="text-purple-500 ">Home</a></li>
                        <li><a href="#about" className="text-purple-500">About</a></li>
                        <li><Link to="/skills" className="text-purple-500">Skills</Link></li>
                        <li><a href="#projects" className="text-purple-500">Projects</a></li>
                        <li><a href="#blogs" className="text-purple-500">Blog</a></li>
                        <li><a href="#contact" className="text-purple-500">Contact</a></li>
                        <div className="icons px-5 pt-10">
                            <a target="_blank" href="https://github.com/WalobwaD"><i className="fa-brands fa-github text-gray-700"></i></a>
                            <a target="_blank" href="https://twitter.com/WalobwaDan"><i className="fa-brands fa-twitter fa-github text-blue-700"></i></a>
                            <a target="_blank" href="https://www.instagram.com/d.antteee/"><i className="fa-brands fa-instagram text-pink-900"></i></a>
                            <a target="_blank" href="https://github.com/WalobwaD" ><i className="fa-brands fa-slack text-red-700"></i></a>
                            <a target="_blank" href="https://discord.com/channels/952919741255807027/980300007821422674"><i className="fa-brands fa-discord text-purple-700"></i></a>
                            <a target="_blank" href="https://www.linkedin.com/in/dan-walobwa-a1bba0212/"><i className="fa-brands fa-linkedin text-blue-700"></i></a>
                            
                        </div>
                    </ul>
                </div>

                <div onClick={navToggle} className={icon}>
                    <div className="line1"></div>
                    <div className="line2"></div>
                    <div className="line3"></div>
                </div>

            </nav>
        </header>
    </section>
    )
}